<script setup>
  import { ref, onMounted, computed, onUnmounted } from "vue";

  const footerData = ref([]);
  const currentYear = computed(() => {
    return new Date().getFullYear();
  });

  const devByText = computed(() => 'DEV BY');

  const shouldLoadFooter = ref(false);
  const fetchFooterData = async () => {
    if (footerData.value.length === 0) {
      footerData.value = await (await fetch("/api/getfooter")).json();
    }
  };
  const footerRef = ref(null);
  const handleScroll = () => {
    if (footerRef.value && !shouldLoadFooter.value) {
      const rect = footerRef.value.getBoundingClientRect();
      if (rect.top <= (window.innerHeight)) {
        shouldLoadFooter.value = true;
        fetchFooterData();
        window.removeEventListener('scroll', handleScroll);
      }
    }
  };


  const getLinkAttributes = (link) => {
    if (!link) return { target: '_parent' };

    const pattern = /^(?:ftp|https?|feed)?:?\/\/(?:(?:(?:[\w\.\-\+!$&'\(\)*\+,;=]|%[0-9a-f]{2})+:)*(?:[\w\.\-\+%!$&'\(\)*\+,;=]|%[0-9a-f]{2})+@)?(?:(?:[a-z0-9\-\.]|%[0-9a-f]{2})+|(?:\[(?:[0-9a-f]{0,4}:)*(?:[0-9a-f]{0,4})\]))(?::[0-9]+)?(?:[\/|\?](?:[\w#!:\.\?\+\|=&@$'~*,;\/\(\)\[\]\-]|%[0-9a-f]{2})*)?$/i;

    if (pattern.test(link)) {
      return {
        target: '_blank',
        rel: 'noopener noreferrer'
      };
    } else {
      return {
        target: '_parent'
      };
    }
  };

  onMounted(() => {
    window.addEventListener('scroll', handleScroll);
    handleScroll();
  });

  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
  });



</script>

<template>
  <footer class="basic-footer-content" ref="footerRef">
    <div class="col-12 container">
      <div class="logo">
        <a href="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="130" height="100" viewBox="0 0 146 80" fill="none">
            <g clip-path="url(#clip0_329_1379)">
              <path d="M145.101 57.5283H6.05859V80H145.101V57.5283Z" fill="#A6A7A7" />
              <path d="M24.9707 39.9617H16.2737L8.75391 47.8958H17.4489L24.9707 39.9617Z" fill="#155B98" />
              <path
                d="M17.6039 48.2592H7.9043L16.1162 39.5961H25.8179L17.606 48.2592H17.6039ZM9.60107
                47.5302H17.2893L24.1211 40.3251H16.4328L9.6031 47.5302H9.60107Z"
                fill="#191915" />
              <path
                d="M6.66235 46.9871L14.1355 39.3074V20.9936H28.625V14.9213H14.1274L14.1355 0.85022L6.66235
                7.93019L6.68265 14.9213H1.26758V20.8563H6.68265L6.66235 46.9871Z"
                fill="#155B98" />
              <path
                d="M6.29509 47.8877L6.31538 21.2197H0.902344V14.5578H6.31538L6.29509 7.77464L14.5009 0L14.4928
                14.5578H28.9905V21.357H14.5009V39.4548L6.29509 47.8877ZM1.63504 20.4927H7.05011L7.02982
                46.0885L13.7702 39.162V20.6301H28.2598V15.2868H13.7621L13.7682 1.70032L7.02779 8.08562L7.04808
                15.2847H1.63504V20.4907V20.4927Z"
                fill="#191915" />
              <path d="M78.305 13.9539L69.334 23.0634V13.8186H78.305V13.9539Z" fill="#008FCF" />
              <path d="M78.305 13.9539L69.334 23.0634V13.8186H78.305V13.9539Z" fill="#155B98" />
              <path
                d="M68.9688 23.956V13.4552H78.6704V14.1034L68.9688 23.956ZM69.7015 14.1822V22.1709L77.5683
                14.1822H69.7015Z"
                fill="#191915" />
              <path d="M94.3125 47.8715L103.281 38.7661V48.0109H94.3125V47.8715Z" fill="#155B98" />
              <path
                d="M103.649 48.3744H93.9453V47.7221L103.649 37.8716V48.3724V48.3744ZM95.0474
                47.6454H102.916V39.6567L95.0474 47.6454Z"
                fill="#191915" />
              <path
                d="M94.0636 35.6865C92.45 38.5278 89.3974 40.4402 85.8963 40.4402C80.7147 40.4402 76.5133 36.2419
                76.5133 31.0621C76.5133 25.8824 80.7147 21.6821 85.8963 21.6821C89.4827 21.6821 92.5982 23.6934
                94.1793 26.6457H103.284V13.8186H81.7579L69.4766 26.0965V47.9705H91.0029L103.122 35.5936L94.0656
                35.6865H94.0636Z"
                fill="#155B98" />
              <path
                d="M91.1534 48.334H69.1055V25.945L81.6019 13.4531H103.648V27.0093H93.9584L93.8548 26.8154C92.2799
                23.8732 89.2293 22.0456 85.8946 22.0456C80.922 22.0456 76.8769 26.0904 76.8769 31.0602C76.8769 36.0299
                80.922 40.0747 85.8946 40.0747C89.1359 40.0747 92.1439 38.3239 93.7432 35.5048L93.8467 35.3211L103.995
                35.216L91.1534 48.3299V48.334ZM69.8382 47.607H90.8449L102.241 35.9673L94.273 36.0501C92.5173 38.9903
                89.3267 40.8057 85.8926 40.8057C80.5161 40.8057 76.1422 36.4358 76.1422 31.0622C76.1422 25.6886
                80.5161 21.3186 85.8926 21.3186C89.4242 21.3186 92.6614 23.2148 94.3927
                26.2823H102.915V14.1821H81.9064L69.8382 26.2459V47.605V47.607Z"
                fill="#191915" />
              <path d="M27.5215 32.1688H33.0421L27.5215 37.6858V32.1688Z" fill="#A6A7A7" />
              <path d="M27.1562 38.5682V31.8053H33.9231L27.1562 38.5682ZM27.8869 32.5323V36.8033L32.1593 32.5323H27.8869Z"
                    fill="#191915" />
              <path d="M45.8076 47.8372H40.2891L45.8076 42.3182V47.8372Z" fill="#A6A7A7" />
              <path d="M46.173 48.2007H39.4082L46.173 41.4337V48.2007ZM41.1699 47.4717H45.4423V43.1987L41.1699 47.4717Z"
                    fill="#191915" />
              <path
                d="M36.3545 36.4055C34.2762 36.4055 32.5916 38.0897 32.5916 40.1676C32.5916 42.2456 34.2762 43.9318
                36.3545 43.9318C38.4329 43.9318 40.1175 42.2476 40.1175 40.1676C40.1175 38.0877 38.4329 36.4055
                36.3545 36.4055ZM27.5216 40.0303L35.3884 32.1648H45.6645L45.6503 40.0222L37.7692
                47.8938H27.5195V40.0283L27.5216 40.0303Z"
                fill="#A6A7A7" />
              <path
                d="M37.9235 48.2593H27.1562V39.8809L35.2362 31.8033H46.0319L46.0177 40.1757L37.9235
                48.2613V48.2593ZM27.8869 47.5303H37.617L45.2829 39.8728L45.2951 32.5303H35.5366L27.8849
                40.1818V47.5323L27.8869 47.5303ZM36.3546 44.2953C34.0773 44.2953 32.2243 42.4435 32.2243
                40.1676C32.2243 37.8918 34.0773 36.042 36.3546 36.042C38.6318 36.042 40.4849 37.8938 40.4849
                40.1676C40.4849 42.4415 38.6318 44.2953 36.3546 44.2953ZM36.3546 36.769C34.4812 36.769 32.9569
                38.2937 32.9569 40.1676C32.9569 42.0416 34.4812 43.5663 36.3546 43.5663C38.2279 43.5663 39.7522
                42.0416 39.7522 40.1676C39.7522 38.2937 38.2279 36.769 36.3546 36.769Z"
                fill="#191915" />
              <path d="M106.455 32.1688H111.976L106.455 37.6858V32.1688Z" fill="#A6A7A7" />
              <path d="M106.09 38.5682V31.8053H112.857L106.09 38.5682ZM106.823 32.5323V36.8033L111.095 32.5323H106.823Z"
                    fill="#191915" />
              <path d="M124.598 47.8958H119.822L124.598 43.2775V47.8958Z" fill="#A6A7A7" />
              <path d="M124.964 48.2593H118.92L124.964 42.4152V48.2593ZM120.724 47.5303H124.231V44.1377L120.724 47.5303Z"
                    fill="#191915" />
              <path
                d="M118.629 38.2068C117.963 37.1486 116.63 36.4055 115.288 36.4055C113.946 36.4055 112.652 37.2032
                111.976 38.2068H118.629ZM111.537 40.4705C111.69 42.4071 113.311 43.9318 115.286 43.9318C116.155
                43.9318 116.954 43.6369 117.59 43.1442L122.201 43.1018L117.214 47.8958H106.455V40.0303L114.32
                32.1648H124.517V40.416L111.537 40.4685V40.4705Z"
                fill="#A6A7A7" />
              <path
                d="M117.364 48.2593H106.09V39.8808L114.168 31.8013H124.882V40.7795L111.955 40.8299C112.266 42.3909
                113.658 43.5642 115.286 43.5642C116.047 43.5642 116.766 43.3178 117.366 42.8534L117.464
                42.7766L123.116 42.7241L117.364 48.2552V48.2593ZM106.823 47.5303H117.068L121.288 43.4733L117.716
                43.5056C117.007 44.0226 116.169 44.2952 115.288 44.2952C113.149 44.2952 111.341 42.6272 111.174
                40.4967L111.144 40.105L124.154 40.0525V32.5262H114.476L106.825 40.1777V47.5283L106.823
                47.5303ZM119.289 38.5703H111.288L111.669 38.0028C112.449 36.8477 113.934 36.04 115.286
                36.04C116.729 36.04 118.197 36.8316 118.937 38.0109L119.287 38.5682L119.289 38.5703ZM112.761
                37.8433H117.87C117.206 37.185 116.242 36.771 115.286 36.771C114.401 36.771 113.443 37.191 112.759
                37.8433H112.761Z"
                fill="#191915" />
              <path d="M127.809 32.1688H133.327L127.809 37.6858V32.1688Z" fill="#A6A7A7" />
              <path d="M127.441 38.5682V31.8053H134.208L127.441 38.5682ZM128.174 32.5323V36.8033L132.446
              32.5323H128.174Z"
                    fill="#191915" />
              <path
                d="M132.595 47.8958H127.807V40.0303L135.674 32.1688H143.743V40.309H140.49C140.49 40.309 140.394
                36.3994 136.451 36.3994C133.792 36.3994 132.58 38.3078 132.58 39.2811C132.58 40.832 132.597
                47.8958 132.597 47.8958"
                fill="#A6A7A7" />
              <path
                d="M132.962 48.2593H127.441V39.8808L135.521 31.8053H144.109V40.6744H140.131L140.123 40.319C140.119
                40.1736 139.98 36.7649 136.449 36.7649C133.952 36.7649 132.946 38.54 132.946 39.2811C132.946 40.834
                132.962 47.8978 132.962 47.8978V48.2633V48.2593ZM128.174 47.5303H132.229C132.225 46.0642 132.213
                40.6179 132.213 39.277C132.213 38.1805 133.492 36.0339 136.449 36.0339C139.964 36.0339 140.677
                38.9196 140.821 39.9434H143.378V32.5303H135.826L128.174 40.1797V47.5303Z"
                fill="#191915" />
              <path d="M48.084 32.1688H53.6026L48.084 37.6858V32.1688Z" fill="#A6A7A7" />
              <path d="M47.7188 38.5682V31.8053H54.4835L47.7188 38.5682ZM48.4494 32.5323V36.8033L52.7218
              32.5323H48.4494Z"
                    fill="#191915" />
              <path d="M66.3701 47.8958H60.8516L66.3701 42.3768V47.8958Z" fill="#A6A7A7" />
              <path d="M66.7374 48.2593H59.9727L66.7374 41.4944V48.2593ZM61.7323 47.5303H66.0047V43.2593L61.7323
              47.5303Z"
                    fill="#191915" />
              <path
                d="M57.1483 36.4055C55.07 36.4055 53.3854 38.0897 53.3854 40.1676C53.3854 42.2456 55.07 43.9318
                57.1483 43.9318C59.2267 43.9318 60.9113 42.2476 60.9113 40.1676C60.9113 38.0877 59.2267 36.4055
                57.1483 36.4055ZM48.084 40.0303L55.9488 32.1648H66.231L66.2127 40.0222L58.3336 47.8938H53.7426L53.8806
                62.9867L48.086 67.815V40.0283L48.084 40.0303Z"
                fill="#A6A7A7" />
              <path
                d="M47.7188 68.5965V39.8808L55.7967 31.8013H66.5984L66.5781 40.1736L58.486 48.2593H54.1121L54.2481
                63.1563L47.7188 68.5965ZM48.4494 40.1817V67.0375L53.5113 62.819L53.3713 47.5323H58.1795L65.8454
                39.8748L65.8637 32.5323H56.1011L48.4494 40.1837V40.1817ZM57.1484 44.2952C54.8712 44.2952 53.0202
                42.4434 53.0202 40.1676C53.0202 37.8917 54.8712 36.042 57.1484 36.042C59.4257 36.042 61.2787 37.8938
                61.2787 40.1676C61.2787 42.4414 59.4257 44.2952 57.1484 44.2952ZM57.1484 36.771C55.2751 36.771
                53.7529 38.2956 53.7529 40.1696C53.7529 42.0436 55.2771 43.5682 57.1484 43.5682C59.0198 43.5682 60.546
                42.0436 60.546 40.1696C60.546 38.2956 59.0218 36.771 57.1484 36.771Z"
                fill="#191915" />
              <path
                d="M140.729 13.3704C141.683 13.3704 142.501 13.7076 143.181 14.3861C143.861 15.0626 144.202 15.8825
                144.202 16.8376C144.202 17.7928 143.861 18.6127 143.181 19.2912C142.501 19.9717 141.683 20.311 140.729
                20.311C139.775 20.311 138.939 19.9738 138.259 19.2952C137.577 18.6187 137.238 17.7989 137.238
                16.8376C137.238 15.8764 137.577 15.0626 138.259 14.3861C138.941 13.7076 139.765 13.3704 140.729
                13.3704ZM140.723 13.849C139.909 13.849 139.211 14.1397 138.635 14.7213C138.056 15.3029 137.768 16.0097
                137.768 16.8376C137.768 17.6656 138.056 18.3704 138.635 18.958C139.213 19.5416 139.909 19.8324 140.723
                19.8324C141.537 19.8324 142.233 19.5416 142.808 18.958C143.382 18.3704 143.668 17.6656 143.668
                16.8376C143.668 16.0097 143.382 15.309 142.808 14.7234C142.233 14.1377 141.537 13.8469 140.723
                13.8469V13.849ZM139.065 18.748V14.8627H141.054C141.933 14.8627 142.371 15.2645 142.371 16.0723C142.371
                16.6539 142.172 17.0073 141.77 17.1224C142.14 17.2133 142.327 17.4677 142.327
                17.8877V18.75H141.505V18.0331C141.505 17.6656 141.314 17.4839 140.934
                17.4839H139.887V18.75H139.065V18.748ZM139.887 16.7831H140.934C141.369 16.7831 141.586 16.5792
                141.586 16.1652C141.586 15.7512 141.385 15.5614 140.985 15.5614H139.887V16.7831Z"
                fill="#A6A7A7" />
              <path
                d="M17.3613 76.5933V69.7092H18.2767V76.5933H17.3613ZM19.7827 76.5933V71.6074H20.5479V72.3162C20.9152
                71.769 21.447 71.4944 22.1432 71.4944C22.4456 71.4944 22.7236 71.5489 22.9753 71.6559C23.229 71.765
                23.4178 71.9063 23.5436 72.082C23.6694 72.2577 23.7567 72.4657 23.8075 72.706C23.8379 72.8635 23.8541
                73.1361 23.8541 73.5279V76.5933H23.0037V73.5602C23.0037 73.2149 22.9712 72.9584 22.9043
                72.7888C22.8373 72.6192 22.7216 72.4818 22.5531 72.3809C22.3847 72.2779 22.1878 72.2274 21.9605
                72.2274C21.5992 72.2274 21.2866 72.3425 21.0228 72.5707C20.761 72.7989 20.629 73.233 20.629
                73.8712V76.5953H19.7786L19.7827 76.5933ZM28.4086 76.5933V75.9633C28.09 76.458 27.6232 76.7044
                27.0062 76.7044C26.6063 76.7044 26.239 76.5953 25.9041 76.3752C25.5692 76.1571 25.3094 75.8502 25.1247
                75.4564C24.94 75.0646 24.8487 74.6123 24.8487 74.1014C24.8487 73.5905 24.9319 73.1523 25.0983
                72.7464C25.2647 72.3405 25.5144 72.0295 25.8493 71.8134C26.1821 71.5973 26.5556 71.4903 26.9676
                71.4903C27.27 71.4903 27.5379 71.5529 27.7754 71.6801C28.0108 71.8074 28.2036 71.973 28.3518
                72.1749V69.7052H29.1961V76.5893H28.4086V76.5933ZM25.7234 74.1034C25.7234 74.7415 25.8594 75.2201
                26.1294 75.5351C26.3993 75.8522 26.72 76.0097 27.0873 76.0097C27.4547 76.0097 27.7734 75.8583 28.0332
                75.5574C28.2929 75.2545 28.4228 74.794 28.4228 74.1741C28.4228 73.4915 28.2909 72.9907 28.0271
                72.6717C27.7632 72.3526 27.4364 72.1931 27.0508 72.1931C26.6652 72.1931 26.3587 72.3465 26.105
                72.6535C25.8513 72.9604 25.7255 73.4431 25.7255 74.1034H25.7234ZM33.8176 76.5933V75.8603C33.4279
                76.4237 32.8982 76.7044 32.2264 76.7044C31.9301 76.7044 31.654 76.6478 31.3983 76.5347C31.1426 76.4217
                30.9518 76.2803 30.828 76.1107C30.7042 75.939 30.6169 75.731 30.5661 75.4847C30.5316 75.3191 30.5134
                75.0566 30.5134 74.6951V71.6054H31.3638V74.372C31.3638 74.8142 31.38 75.1111 31.4166 75.2645C31.4693
                75.4867 31.583 75.6603 31.7555 75.7876C31.928 75.9148 32.1432 75.9774 32.3969 75.9774C32.6506 75.9774
                32.8901 75.9128 33.1133 75.7815C33.3366 75.6523 33.4949 75.4746 33.5883 75.2504C33.6816 75.0263
                33.7283 74.7011 33.7283 74.2751V71.6034H34.5787V76.5893H33.8196L33.8176 76.5933ZM32.0336
                70.9855L32.6607 69.6709H33.775L32.7379 70.9855H32.0356H32.0336ZM35.5692 75.105L36.4095 74.9738C36.4561
                75.309 36.5881 75.5654 36.8032 75.7431C37.0184 75.9208 37.3208 76.0097 37.7064 76.0097C38.092 76.0097
                38.3863 75.9309 38.5751 75.7714C38.7638 75.6139 38.8572 75.4281 38.8572 75.2161C38.8572 75.0242
                38.774 74.8748 38.6076 74.7658C38.4919 74.691 38.2016 74.5941 37.7389 74.479C37.1158 74.3215 36.6835
                74.1862 36.444 74.0731C36.2024 73.958 36.0198 73.8005 35.896 73.5986C35.7722 73.3966 35.7092 73.1725
                35.7092 72.9301C35.7092 72.708 35.76 72.502 35.8635 72.3122C35.967 72.1224 36.105 71.9649 36.2816
                71.8397C36.4135 71.7427 36.5942 71.6599 36.8215 71.5933C37.0488 71.5267 37.2944 71.4923 37.5562
                71.4923C37.95 71.4923 38.295 71.5489 38.5913 71.662C38.8876 71.7751 39.1089 71.9285 39.2489
                72.1204C39.391 72.3122 39.4884 72.5707 39.5412 72.8918L38.7111 73.0049C38.6725 72.7484 38.5649
                72.5485 38.3823 72.4031C38.2016 72.2597 37.9459 72.187 37.6151 72.187C37.2254 72.187 36.9473 72.2516
                36.7789 72.3789C36.6104 72.5061 36.5292 72.6575 36.5292 72.8292C36.5292 72.9382 36.5637 73.0372
                36.6327 73.124C36.7017 73.2149 36.8113 73.2896 36.9575 73.3502C37.0427 73.3825 37.2924 73.4532 37.7084
                73.5662C38.3092 73.7258 38.7293 73.857 38.9668 73.958C39.2043 74.061 39.391 74.2084 39.525
                74.4023C39.6609 74.5961 39.7279 74.8385 39.7279 75.1252C39.7279 75.412 39.6447 75.6725 39.4803
                75.9209C39.3159 76.1692 39.0764 76.3631 38.7659 76.4984C38.4553 76.6337 38.1022 76.7024 37.7084
                76.7024C37.0569 76.7024 36.5617 76.5671 36.2187 76.2985C35.8777 76.0299 35.6585 75.6301 35.5651
                75.101L35.5692 75.105ZM42.5958 75.836L42.7196 76.5832C42.4801 76.6337 42.267 76.6579 42.0782
                76.6579C41.7697 76.6579 41.5302 76.6095 41.3618 76.5125C41.1913 76.4156 41.0715 76.2884 41.0025
                76.1288C40.9335 75.9693 40.899 75.6381 40.899 75.1313V72.2617H40.2759V71.6054H40.899V70.3696L41.7433
                69.8627V71.6054H42.5978V72.2617H41.7433V75.1777C41.7433 75.418 41.7576 75.5735 41.788 75.6422C41.8184
                75.7108 41.8672 75.7654 41.9341 75.8057C42.0011 75.8461 42.0985 75.8663 42.2244 75.8663C42.3198
                75.8663 42.4436 75.8562 42.5978 75.834L42.5958 75.836ZM43.4158 76.5933V71.6074H44.1809V72.3627C44.3758
                72.0093 44.5564 71.7751 44.7208 71.662C44.8852 71.5489 45.0679 71.4923 45.2668 71.4923C45.553
                71.4923 45.8432 71.5832 46.1395 71.765L45.8473 72.5485C45.6402 72.4253 45.4312 72.3647 45.2242
                72.3647C45.0395 72.3647 44.871 72.4192 44.7249 72.5323C44.5767 72.6434 44.4712 72.7969 44.4083
                72.9948C44.3129 73.2957 44.2662 73.6228 44.2662 73.9802V76.5913H43.4158V76.5933ZM46.649
                70.6805V69.7092H47.4994V70.6805H46.649ZM46.649 76.5933V71.6074H47.4994V76.5933H46.649ZM52.062
                75.9774C51.7474 76.244 51.445 76.4318 51.1527 76.5408C50.8625 76.6499 50.5499 76.7044 50.215
                76.7044C49.665 76.7044 49.2408 76.5711 48.9465 76.3025C48.6502 76.036 48.502 75.6927 48.502
                75.2767C48.502 75.0323 48.5589 74.8102 48.6705 74.6082C48.7821 74.4063 48.9283 74.2448 49.1089
                74.1216C49.2895 74.0004 49.4945 73.9075 49.7198 73.8449C49.8862 73.8005 50.1379 73.7581 50.4748
                73.7177C51.1609 73.6369 51.6662 73.54 51.9889 73.4269C51.993 73.3118 51.993 73.2371 51.993
                73.2068C51.993 72.8635 51.9118 72.6192 51.7515 72.4798C51.5343 72.288 51.2116 72.1931 50.7833
                72.1931C50.3835 72.1931 50.0892 72.2637 49.8984 72.4011C49.7076 72.5404 49.5676 72.7868 49.4763
                73.1402L48.6461 73.0271C48.7212 72.6737 48.845 72.3889 49.0196 72.1709C49.1921 71.9528 49.4418 71.7851
                49.7706 71.668C50.0973 71.5509 50.4769 71.4923 50.9072 71.4923C51.3374 71.4923 51.6825 71.5428 51.9504
                71.6418C52.2183 71.7427 52.4152 71.8679 52.541 72.0194C52.6668 72.1709 52.7541 72.3627 52.8049
                72.5949C52.8333 72.7383 52.8475 72.9988 52.8475 73.3744V74.5012C52.8475 75.2868 52.8658 75.7835
                52.9023 75.9915C52.9388 76.1995 53.0099 76.3994 53.1174 76.5893H52.2305C52.1432 76.4136 52.0864
                76.2096 52.06 75.9734L52.062 75.9774ZM51.991 74.0893C51.6825 74.2145 51.2197 74.3215 50.6027
                74.4083C50.2536 74.4588 50.006 74.5154 49.8619 74.578C49.7178 74.6406 49.6062 74.7314 49.527
                74.8526C49.4478 74.9738 49.4093 75.107 49.4093 75.2545C49.4093 75.4806 49.4945 75.6684 49.667
                75.8179C49.8396 75.9673 50.0892 76.044 50.42 76.044C50.7509 76.044 51.0391 75.9734 51.2928
                75.83C51.5465 75.6866 51.7352 75.4927 51.855 75.2464C51.9463 75.0545 51.991 74.7738 51.991
                74.4003V74.0913V74.0893ZM60.1034 76.5933V75.9633C59.7848 76.458 59.318 76.7044 58.701 76.7044C58.3011
                76.7044 57.9338 76.5953 57.5989 76.3752C57.264 76.1571 57.0042 75.8502 56.8195 75.4564C56.6348
                75.0646 56.5435 74.6123 56.5435 74.1014C56.5435 73.5905 56.6267 73.1523 56.7931 72.7464C56.9595
                72.3405 57.2092 72.0295 57.5441 71.8134C57.8769 71.5973 58.2504 71.4903 58.6624 71.4903C58.9648
                71.4903 59.2327 71.5529 59.4702 71.6801C59.7056 71.8074 59.8984 71.973 60.0466
                72.1749V69.7052H60.8909V76.5893H60.1034V76.5933ZM57.4182 74.1034C57.4182 74.7415 57.5542 75.2201
                57.8242 75.5351C58.0941 75.8522 58.4148 76.0097 58.7821 76.0097C59.1495 76.0097 59.4682 75.8583
                59.7279 75.5574C59.9877 75.2545 60.1176 74.794 60.1176 74.1741C60.1176 73.4915 59.9857 72.9907
                59.7219 72.6717C59.458 72.3526 59.1312 72.1931 58.7456 72.1931C58.36 72.1931 58.0535 72.3465
                57.7998 72.6535C57.5461 72.9604 57.4202 73.4431 57.4202 74.1034H57.4182ZM65.6585 74.9879L66.5353
                75.0949C66.3973 75.6058 66.1396 76.0016 65.7661 76.2823C65.3927 76.563 64.9137 76.7044 64.3312
                76.7044C63.5985 76.7044 63.016 76.4802 62.5877 76.0299C62.1574 75.5816 61.9443 74.9515 61.9443
                74.1398C61.9443 73.328 62.1615 72.6494 62.5958 72.187C63.0302 71.7246 63.5924 71.4923 64.2845
                71.4923C64.9766 71.4923 65.5023 71.7185 65.9265 72.1729C66.3507 72.6272 66.5638 73.2654 66.5638
                74.0893C66.5638 74.1398 66.5638 74.2145 66.5597 74.3154H62.8231C62.8536 74.8627 63.0099 75.2827 63.29
                75.5735C63.57 75.8643 63.9191 76.0097 64.3373 76.0097C64.6478 76.0097 64.9137 75.9289 65.1349
                75.7654C65.3541 75.6038 65.5286 75.3433 65.6585 74.9859V74.9879ZM62.8698 73.6208H65.6687C65.6301
                73.2007 65.5246 72.8877 65.348 72.6777C65.0781 72.3526 64.7269 72.189 64.2967 72.189C63.907 72.189
                63.5782 72.3183 63.3123 72.5788C63.0464 72.8393 62.9003 73.1866 62.8719 73.6208H62.8698ZM75.3318
                74.1801L76.2472 74.4104C76.0564 75.1595 75.7093 75.729 75.212 76.1228C74.7127 76.5166 74.1039 76.7125
                73.3833 76.7125C72.6628 76.7125 72.0316 76.561 71.5648 76.2601C71.098 75.9592 70.7428 75.521 70.4992
                74.9475C70.2557 74.374 70.1339 73.7601 70.1339 73.1018C70.1339 72.3849 70.2719 71.7589 70.5459
                71.2258C70.8219 70.6927 71.2137 70.2868 71.7211 70.0101C72.2285 69.7335 72.7887 69.5941 73.3996
                69.5941C74.0917 69.5941 74.6742 69.7698 75.1451 70.1192C75.6159 70.4705 75.9447 70.9633 76.1315
                71.5994L75.2303 71.8114C75.07 71.3106 74.8366 70.9451 74.5321 70.7169C74.2277 70.4887 73.842 70.3736
                73.3813 70.3736C72.8495 70.3736 72.4051 70.5008 72.0478 70.7532C71.6906 71.0077 71.4389 71.3469 71.2948
                71.7751C71.1507 72.2032 71.0777 72.6434 71.0777 73.0957C71.0777 73.6814 71.1629 74.1923 71.3354
                74.6284C71.508 75.0646 71.7738 75.3918 72.1351 75.6078C72.4964 75.8239 72.8881 75.931 73.3103
                75.931C73.8238 75.931 74.2581 75.7835 74.6133 75.4887C74.9685 75.1939 75.21 74.7577 75.3338
                74.1781L75.3318 74.1801ZM80.6981 74.9879L81.577 75.0949C81.439 75.6058 81.1812 76.0016 80.8077
                76.2823C80.4323 76.563 79.9553 76.7044 79.3728 76.7044C78.6401 76.7044 78.0596 76.4802 77.6293
                76.0299C77.1991 75.5816 76.9859 74.9515 76.9859 74.1398C76.9859 73.328 77.2031 72.6494 77.6375
                72.187C78.0718 71.7246 78.634 71.4923 79.3261 71.4923C80.0182 71.4923 80.5439 71.7185 80.9681
                72.1729C81.3923 72.6272 81.6054 73.2654 81.6054 74.0893C81.6054 74.1398 81.6054 74.2145 81.6013
                74.3154H77.8627C77.8952 74.8627 78.0495 75.2827 78.3296 75.5735C78.6097 75.8643 78.9588 76.0097
                79.3769 76.0097C79.6874 76.0097 79.9533 75.9289 80.1745 75.7654C80.3937 75.6038 80.5682 75.3433
                80.6981 74.9859V74.9879ZM77.9094 73.6208H80.7083C80.6718 73.2007 80.5642 72.8877 80.3876
                72.6777C80.1177 72.3526 79.7665 72.189 79.3363 72.189C78.9466 72.189 78.6178 72.3183 78.3519
                72.5788C78.086 72.8393 77.9378 73.1866 77.9115 73.6208H77.9094ZM82.6324
                76.5933V71.6074H83.3976V72.3627C83.5924 72.0093 83.773 71.7751 83.9374 71.662C84.1018 71.5489
                84.2845 71.4923 84.4834 71.4923C84.7696 71.4923 85.0598 71.5832 85.3562 71.765L85.0639 72.5485C84.8569
                72.4253 84.6478 72.3647 84.4408 72.3647C84.2561 72.3647 84.0876 72.4192 83.9395 72.5323C83.7913
                72.6434 83.6858 72.7969 83.6228 72.9948C83.5295 73.2957 83.4808 73.6228 83.4808
                73.9802V76.5913H82.6324V76.5933ZM89.1313 75.9774C88.8167 76.244 88.5143 76.4318 88.222 76.5408C87.9318
                76.6499 87.6192 76.7044 87.2863 76.7044C86.7363 76.7044 86.3121 76.5711 86.0158 76.3025C85.7195
                76.0339 85.5713 75.6927 85.5713 75.2767C85.5713 75.0323 85.6261 74.8102 85.7398 74.6082C85.8514
                74.4063 85.9975 74.2448 86.1782 74.1216C86.3588 73.9984 86.5618 73.9075 86.7891 73.8449C86.9555
                73.8005 87.2072 73.7581 87.5441 73.7177C88.2301 73.6369 88.7355 73.54 89.0582 73.4269C89.0623
                73.3118 89.0623 73.2371 89.0623 73.2068C89.0623 72.8635 88.9811 72.6192 88.8208 72.4798C88.6036
                72.288 88.2809 72.1931 87.8526 72.1931C87.4528 72.1931 87.1585 72.2637 86.9677 72.4011C86.7769
                72.5404 86.6369 72.7868 86.5455 73.1402L85.7154 73.0271C85.7905 72.6737 85.9143 72.3889 86.0889
                72.1709C86.2634 71.9528 86.511 71.7851 86.8398 71.668C87.1666 71.5509 87.5461 71.4923 87.9764
                71.4923C88.4067 71.4923 88.7517 71.5428 89.0197 71.6418C89.2876 71.7427 89.4844 71.8679 89.6103
                72.0194C89.7361 72.1709 89.8234 72.3627 89.8741 72.5949C89.9025 72.7383 89.9168 72.9988 89.9168
                73.3744V74.5012C89.9168 75.2868 89.935 75.7835 89.9715 75.9915C90.0081 76.1995 90.0791 76.3994
                90.1867 76.5893H89.2997C89.2125 76.4136 89.1556 76.2096 89.1293 75.9734L89.1313 75.9774ZM87.8952
                70.1878L87.3614 70.9855H86.3892L87.4081 69.6709H88.3133L89.3748 70.9855H88.4128L87.8932
                70.1878H87.8952ZM89.0602 74.0893C88.7517 74.2145 88.289 74.3215 87.672 74.4083C87.3229 74.4588 87.0753
                74.5154 86.9312 74.578C86.787 74.6406 86.6754 74.7314 86.5963 74.8526C86.5171 74.9738 86.4786 75.107
                86.4786 75.2545C86.4786 75.4806 86.5638 75.6684 86.7363 75.8179C86.9088 75.9673 87.1585 76.044 87.4893
                76.044C87.8201 76.044 88.1083 75.9734 88.3621 75.83C88.6158 75.6866 88.8045 75.4927 88.9243
                75.2464C89.0156 75.0545 89.0602 74.7738 89.0602 74.4003V74.0913V74.0893ZM91.236
                76.5933V71.6074H91.9951V72.3062C92.1534 72.0618 92.3604 71.8659 92.6223 71.7165C92.8841 71.5671
                93.1804 71.4923 93.5133 71.4923C93.8847 71.4923 94.1891 71.5691 94.4266 71.7226C94.6641 71.876 94.8325
                72.0901 94.93 72.3667C95.3257 71.7851 95.8433 71.4923 96.4786 71.4923C96.9758 71.4923 97.3574 71.6297
                97.6253 71.9043C97.8932 72.1789 98.0272 72.599 98.0272 73.1684V76.5913H97.1828V73.4511C97.1828
                73.1139 97.1544 72.8696 97.0996 72.7201C97.0448 72.5707 96.9434 72.4515 96.7992 72.3607C96.6551
                72.2698 96.4847 72.2254 96.2898 72.2254C95.9367 72.2254 95.6444 72.3425 95.413 72.5747C95.1796 72.809
                95.0639 73.1805 95.0639 73.6955V76.5933H94.2135V73.3542C94.2135 72.9786 94.1445 72.6979 94.0065
                72.5101C93.8685 72.3223 93.6411 72.2294 93.3265 72.2294C93.087 72.2294 92.8658 72.292 92.6628
                72.4172C92.4599 72.5424 92.3117 72.7262 92.2204 72.9665C92.1291 73.2068 92.0844 73.5541 92.0844
                74.0085V76.5953H91.236V76.5933ZM99.2916 70.6805V69.7092H100.14V70.6805H99.2916ZM99.2916
                76.5933V71.6074H100.14V76.5933H99.2916ZM104.705 74.7658L105.541 74.8728C105.45 75.4463 105.216
                75.8946 104.841 76.2177C104.465 76.5408 104.002 76.7044 103.456 76.7044C102.77 76.7044 102.218
                76.4822 101.802 76.036C101.386 75.5897 101.177 74.9495 101.177 74.1175C101.177 73.5784 101.266
                73.1078 101.445 72.704C101.624 72.3001 101.898 71.9972 102.263 71.7952C102.63 71.5933 103.028 71.4923
                103.461 71.4923C104.004 71.4923 104.449 71.6297 104.796 71.9043C105.143 72.1789 105.364 72.5667
                105.462 73.0715L104.636 73.1987C104.557 72.8635 104.419 72.6111 104.218 72.4435C104.019 72.2738
                103.777 72.191 103.493 72.191C103.065 72.191 102.718 72.3445 102.45 72.6494C102.182 72.9544 102.048
                73.437 102.048 74.0973C102.048 74.7577 102.178 75.2545 102.436 75.5574C102.693 75.8603 103.03
                76.0137 103.446 76.0137C103.779 76.0137 104.057 75.9128 104.28 75.7088C104.504 75.5049 104.646
                75.1919 104.705 74.7698V74.7658ZM109.537 75.9774C109.223 76.244 108.92 76.4318 108.628 76.5408C108.338
                76.6499 108.025 76.7044 107.692 76.7044C107.142 76.7044 106.718 76.5711 106.422 76.3025C106.125
                76.0339 105.977 75.6927 105.977 75.2767C105.977 75.0323 106.032 74.8102 106.146 74.6082C106.257
                74.4063 106.403 74.2448 106.584 74.1216C106.765 73.9984 106.968 73.9075 107.195 73.8449C107.361
                73.8005 107.613 73.7581 107.95 73.7177C108.636 73.6369 109.141 73.54 109.464 73.4269C109.468 73.3118
                109.468 73.2371 109.468 73.2068C109.468 72.8635 109.387 72.6192 109.227 72.4798C109.01 72.288 108.687
                72.1931 108.259 72.1931C107.859 72.1931 107.564 72.2637 107.374 72.4011C107.183 72.5404 107.043
                72.7868 106.951 73.1402L106.121 73.0271C106.196 72.6737 106.32 72.3889 106.495 72.1709C106.669 71.9528
                106.917 71.7851 107.246 71.668C107.573 71.5509 107.952 71.4923 108.382 71.4923C108.813 71.4923 109.158
                71.5428 109.426 71.6418C109.694 71.7427 109.89 71.8679 110.016 72.0194C110.142 72.1709 110.229 72.3627
                110.28 72.5949C110.309 72.7383 110.323 72.9988 110.323 73.3744V74.5012C110.323 75.2868 110.341 75.7835
                110.378 75.9915C110.414 76.1995 110.485 76.3994 110.593 76.5893H109.706C109.618 76.4136 109.562
                76.2096 109.535 75.9734L109.537 75.9774ZM109.466 74.0893C109.158 74.2145 108.695 74.3215 108.078
                74.4083C107.729 74.4588 107.481 74.5154 107.337 74.578C107.193 74.6406 107.081 74.7314 107.002
                74.8526C106.923 74.9738 106.885 75.107 106.885 75.2545C106.885 75.4806 106.97 75.6684 107.142
                75.8179C107.315 75.9673 107.564 76.044 107.895 76.044C108.226 76.044 108.514 75.9734 108.768
                75.83C109.022 75.6866 109.21 75.4927 109.33 75.2464C109.422 75.0545 109.466 74.7738 109.466
                74.4003V74.0913V74.0893ZM111.863 76.5933V75.6301H112.831V76.5933C112.831 76.9467 112.768 77.2335
                112.643 77.4495C112.517 77.6676 112.318 77.8352 112.044 77.9544L111.808 77.5929C111.987 77.5141
                112.119 77.399 112.204 77.2476C112.289 77.0961 112.336 76.878 112.346 76.5933H111.865H111.863ZM116.809
                74.3821L117.674 74.3074C117.715 74.6527 117.81 74.9334 117.96 75.1555C118.11 75.3756 118.342 75.5553
                118.656 75.6906C118.971 75.8259 119.324 75.8946 119.718 75.8946C120.067 75.8946 120.376 75.8421
                120.643 75.7391C120.911 75.6361 121.11 75.4948 121.24 75.313C121.37 75.1333 121.437 74.9374 121.437
                74.7234C121.437 74.5093 121.374 74.3195 121.248 74.1579C121.122 73.9964 120.915 73.8611 120.625
                73.752C120.44 73.6793 120.028 73.5683 119.393 73.4168C118.758 73.2654 118.313 73.122 118.058
                72.9867C117.727 72.815 117.481 72.601 117.319 72.3465C117.157 72.0921 117.075 71.8053 117.075
                71.4903C117.075 71.143 117.175 70.8179 117.374 70.517C117.573 70.2141 117.861 69.9859 118.242
                69.8284C118.622 69.6709 119.046 69.5941 119.513 69.5941C120.026 69.5941 120.477 69.6769 120.869
                69.8405C121.26 70.0041 121.561 70.2464 121.772 70.5654C121.983 70.8845 122.097 71.246 122.111
                71.6498L121.232 71.7165C121.185 71.2823 121.025 70.9532 120.753 70.731C120.481 70.5089 120.079
                70.3978 119.547 70.3978C119.016 70.3978 118.589 70.4988 118.338 70.7007C118.084 70.9027 117.958
                71.145 117.958 71.4318C117.958 71.6781 118.048 71.8821 118.226 72.0416C118.403 72.2011 118.863
                72.3647 119.606 72.5323C120.349 72.6999 120.861 72.8453 121.139 72.9705C121.541 73.1543 121.839
                73.3885 122.03 73.6733C122.22 73.958 122.318 74.2831 122.318 74.6527C122.318 75.0222 122.212
                75.3635 122.001 75.6886C121.79 76.0117 121.488 76.2641 121.092 76.4439C120.698 76.6236 120.254
                76.7145 119.758 76.7145C119.133 76.7145 118.608 76.6236 118.186 76.4419C117.763 76.2601 117.43
                75.9875 117.189 75.622C116.947 75.2585 116.822 74.8445 116.809 74.3841V74.3821ZM123.7
                76.5933V75.6301H124.668V76.5933H123.7ZM125.492 76.5933L128.149 69.7092H129.135L131.967
                76.5933H130.924L130.116 74.5093H127.223L126.464 76.5933H125.492ZM127.489 73.7662H129.836L129.113
                71.8599C128.894 71.2803 128.729 70.8057 128.622 70.4322C128.533 70.8744 128.409 71.3126 128.248
                71.7468L127.489 73.7662ZM132.831 76.5933V75.6301H133.8V76.5933H132.831Z"
                fill="white" />
            </g>
            <defs>
              <clipPath id="clip0_329_1379">
                <rect width="144.198" height="80" fill="white" transform="translate(0.902344)" />
              </clipPath>
            </defs>
          </svg>
        </a>

      </div>
    </div>
    <hr>
    <div class="container-lg container" v-if="shouldLoadFooter">
      <div class="container-info">
        <div class="footer-inicial">
          <div v-for="item in footerData.footer_menu" :key="item.id">
            <a :href="item.link" v-bind="getLinkAttributes(item.link)">
              {{ item.label }}
            </a>
          </div>
        </div>
        <div class="footer-colection">
          <div v-for="item in footerData.footer_collection" :key="item.id">
            <a :href="item.link" v-bind="getLinkAttributes(item.link)">
              {{ item.alternative || item.label }}
            </a>
          </div>
        </div>
        <div class="footer-terms">
          <div v-for="item in footerData.footer_terms" :key="item.id">
            <a :href="item.link" v-bind="getLinkAttributes(item.link)">
              {{ item.label }}
            </a>
          </div>
        </div>
        <div class="social-media">
          <div v-for="item in footerData.social_media_menu" :key="item.id">
            <a :href="item.link" v-bind="getLinkAttributes(item.link)">
              {{ item.label }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="container">
        <div class="create-by">
          <div class="site">
            &copy; {{ currentYear }}
            <a href="/en" class="site-name" target="_blank" title="TOPCER" alt="Topcer-Indústria de Cerâmica, S.A">
              topcer &reg;
            </a>
          </div>
          <p>
            {{ devByText }}
            <a target="_blank" href="https://incograf.com/"> Incograf &reg; </a>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>


<style scoped>

</style>
